let defaultURI = "https://api.liquifynft.com/v1";
export async function getApi(uri) {
    const resp = await fetch(fullUri(uri));
    return resp.json();
}
export async function postApi(uri, data) {
    const resp = await fetch(fullUri(uri), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
    return resp.json();
}
export function fullUri(path) {
    return `${baseURI()}/${path}`;
}
export function baseURI() {
    return defaultURI;
}
export function setBaseURI(base) {
    defaultURI = base;
}
